import { Box, Paper, Slider, Typography } from "@mui/material";
import { MIN_THICKNESS, MAX_THICKNESS } from "../constants";
import { useTranslation } from "react-i18next";

interface ThicknessControlProps {
  thickness: number;
  onThicknessChange: (value: number) => void;
  popupAbove: boolean;
}

export default function ThicknessControl({
  thickness,
  onThicknessChange,
  popupAbove,
}: ThicknessControlProps) {
  const { t } = useTranslation(["bugherd"]);

  return (
    <Paper
      elevation={4}
      sx={{
        position: "absolute",
        ...(popupAbove
          ? { bottom: "100%", mb: 1 }
          : { top: "100%", mt: 1 }),
        left: "50%",
        transform: "translateX(-50%)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        p: 1.5,
        borderRadius: "12px",
        backgroundColor: "#fff",
        zIndex: 10,
        minWidth: 160,
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <Typography variant="caption" sx={{ color: "text.secondary" }}>
        {t("thickness")}: {thickness}px
      </Typography>
      {/* Line preview */}
      <Box
        sx={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
          py: 0.5,
        }}
      >
        <Box
          sx={{
            width: "80%",
            height: `${Math.max(thickness, 1)}px`,
            backgroundColor: "#333",
            borderRadius: thickness / 2,
          }}
        />
      </Box>
      <Slider
        value={thickness}
        onChange={(_, value) => onThicknessChange(value as number)}
        min={MIN_THICKNESS}
        max={MAX_THICKNESS}
        size="small"
        sx={{
          width: "90%",
          color: "#7C4DFF",
        }}
      />
    </Paper>
  );
}
